"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptTypeDisclaimer;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styles = require("./styles");
var _Banners = require("../../Banners");
var _Markdown = _interopRequireDefault(require("../../Markdown"));
/*eslint-disable react/no-danger*/

const propTypes = {
  provider: (0, _propTypes.shape)({
    provider_type: _propTypes.string
  }).isRequired,
  apptTypeDisclaimers: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    enabled: _propTypes.bool,
    provider_type: _propTypes.string,
    markdown: (0, _propTypes.arrayOf)(_propTypes.string)
  }))
};
const defaultProps = {
  apptTypeDisclaimers: []
};
function ApptTypeDisclaimer(_ref) {
  let {
    provider,
    apptTypeDisclaimers
  } = _ref;
  // Array.find vs Array.match b/c limiting to one disclaimer per provider_type
  const disclaimer = (0, _find.default)(apptTypeDisclaimers).call(apptTypeDisclaimers, apptTypeDisclaimer => {
    const isMatch = apptTypeDisclaimer.provider_type === provider.provider_type;
    return apptTypeDisclaimer.enabled && isMatch;
  });
  return disclaimer ? /*#__PURE__*/_react.default.createElement(Disclaimer, {
    markdown: disclaimer.markdown
  }) : null;
}
function Disclaimer(_ref2) {
  let {
    markdown
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "ApptTypeDisclaimer"
  }, /*#__PURE__*/_react.default.createElement(_Banners.InfoBanner, null, /*#__PURE__*/_react.default.createElement(_Markdown.default, {
    markdown: markdown
  })));
}
ApptTypeDisclaimer.propTypes = propTypes;
ApptTypeDisclaimer.defaultProps = defaultProps;
ApptTypeDisclaimer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptTypeDisclaimer",
  "props": {
    "apptTypeDisclaimers": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "enabled": {
              "name": "bool",
              "required": false
            },
            "provider_type": {
              "name": "string",
              "required": false
            },
            "markdown": {
              "name": "arrayOf",
              "value": {
                "name": "string"
              },
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "provider": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "provider_type": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};